/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox {

    @Serenity.Decorators.registerClass()
    export class ChatroomsDialog extends NoboxEntityDialog<ChatroomsRow, any> {
        protected getFormKey() { return ChatroomsForm.formKey; }
        protected getIdProperty() { return ChatroomsRow.idProperty; }
        protected getLocalTextPrefix() { return ChatroomsRow.localTextPrefix; }
        protected getNameProperty() { return ChatroomsRow.nameProperty; }
        protected getService() { return ChatroomsService.baseUrl; }
        protected getDeletePermission() { return ChatroomsRow.deletePermission; }
        protected getInsertPermission() { return ChatroomsRow.insertPermission; }
        protected getUpdatePermission() { return ChatroomsRow.updatePermission; }

        protected form = new ChatroomsForm(this.idPrefix);
        private agentsGrid: LinkAgentGrid;
        private notesGrid: ChatnotesGrid;
        constructor(container?: JQuery) {
            super(container);
            this.agentsGrid = new LinkAgentGrid(this.byId('AgentsGrid'));
            this.notesGrid = new ChatnotesGrid(this.byId('NotesGrid'));
        }
        

        protected getToolbarButtons() {
            return [];
        }

        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.isEditMode()) {
                Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
                this.element.find('sup').hide();
                if (this.isEditMode()) {
                    var entityType = super.getEntitySingular();

                    // get name field value of record this dialog edits
                    let name = this.getEntityNameFieldValue() || "";

                    // you could use format with a local text, but again demo...
                    this.dialogTitle = 'View ' + entityType /*+ " (" + name + ")"*/;
                }
            }
        }
        setStatus(status) {
            this.element.find(".s-DialogToolbar.s-Serenity-Toolbar .status-link").remove();
            if (status == 2) {
                this.element.find(".s-DialogToolbar.s-Serenity-Toolbar").append(`<div class="status-link lkbadge-md lkbadge lkbadge-primary lkbadge-dim" style="margin-left: auto;">Assign</div>`);
            } else if (status == 3) {
                this.element.find(".s-DialogToolbar.s-Serenity-Toolbar").append(`<div class="status-link lkbadge-md lkbadge lkbadge-success lkbadge-dim" style="margin-left: auto;">Resolved</div>`);
            } else {
                this.element.find(".s-DialogToolbar.s-Serenity-Toolbar").append(`<div class="status-link lkbadge-md lkbadge lkbadge-danger lkbadge-dim" style="margin-left: auto;">Unassign</div>`);
            }
        }
        loadEntity(entity: ChatroomsRow) {
            super.loadEntity(entity);

            //Serenity.TabsExtensions.setDisabled(this.tabs, 'Leads', this.isNewOrDeleted());
            if (!Q.isEmptyOrNull(entity.TagsIds)) {
                var t = JSON.parse(`${entity.TagsIds}`) as [];
                Serenity.EditorUtils.setValue(this.form.TagsIds, t.toString());
            }
            this.setStatus(entity.St);
            this.agentsGrid.roomId = entity.Id;
            this.notesGrid.roomId = entity.Id;
        }
        getTemplate() {
            return `<div id="~_Tabs" class="s-DialogContent">
                        <ul>
                            <li><a href="#~_TabContact"><span>Information</span></a></li>
                            <li><a href="#~_TabAgent"><span>Agents</span></a></li>
                            <li><a href="#~_TabNote"><span>Notes</span></a></li>
                        </ul>
                        <div id="~_TabContact" class="tab-pane s-TabContact">
                            <div id="~_Toolbar" class="s-DialogToolbar">
                            </div>
                            <div class="s-Form">
                                <form id="~_Form" action="">
                                    <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                                        <div id="~_PropertyGrid"></div>
                                        <div class="clear"></div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div id="~_TabAgent" class="tab-pane s-TabAgent">
                            <div id="~_AgentsGrid">
                            </div>
                        </div>
                        <div id="~_TabNote" class="tab-pane s-TabNote">
                            <div id="~_NotesGrid">
                            </div>
                        </div>
                    </div>`;
        }
    }
}